import request from "root/js/request";

export const uploadDefaultCostCrossMP = async ({ cabinet_id }, formData) => {
  const cost_file = formData.get("cost_file");
  if (cost_file) {
    formData.delete("cost_file");
    formData.append("cost_file", cost_file);
  }

  const response = await request({
    url: `/api/analytics/cross-mp/product_cost_v3/upload_default_cost/`,
    method: "post",
    data: formData,
    params: {
      cabinet_id,
    },
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });
  return response;
};
